<template>
    <div class="flex flex-column">
        <nav-bar
            :title="pagetitle?pagetitle:'产品列表'"
            left-arrow
            @click-left="goback(-1)" 
        />
        <list
            v-if="projects.length > 0"
            class="load-list"
            v-model="loading" 
            :finished="finished"
            finished-text="没有更多了"
            @load="more"
        >
            <div class="project-list">
                <div class="project-list-item box-shadow" @click="to_project(item.id)" v-for="item in projects" :key="item.id">
                    <div class="flex">
                        <div class="img_wrap">
                            <!-- <div class="tag gradation1 weight" >拼团</div>
                            <CountDown class="time"></CountDown> -->
                            <van-image fit="cover" lazy-load :src="item.thumb?resUrl + item.thumb:defaultImg">
                                <template v-slot:error>加载失败</template>   
                            </van-image>
                        </div>
                        <div class="flex1 list-content">
                            <div class="van-multi-ellipsis--l2 fs15">{{item.name}}</div>
                            <div class="flex flex-space-between lineheight150 mt-10 align-items-center">
                                <div class="c-999 line-through"></div>
                                <div class="c-orange fs14">
                                    ￥<span class="weight fs18">{{item.min_price}}</span>
                                    <span class="fs14 c-999">起</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </list>
        <div v-else-if="loaded" class="flex flex-column flex-item-center align-items-center mt-20">
            <div class="none404"></div>
            <div class="mt-10" style="color: #788ea8;">暂无数据</div>
        </div>
        <div class="page-end">@游尚智联 技术支持</div>
    </div>
</template>
<script>
import {NavBar,Image,List} from 'vant'
import defaultImg from '../../assets/yszl.jpg'
import { resUrl } from '@/config/env'
export default {
    data(){
        return {
            resUrl:resUrl,
            defaultImg,
            loading:false,
            finished:false,
            loaded:false,
            search:{},
            pagetitle:'',
            projects:[],
            url:'projects',
            page:{
                page:1,
                perpage:10,
                total:0
            }
        }
    },
    components:{
        NavBar,
        VanImage:Image,
        List
    },
    computed:{
    },
    created(){
        if(this.$route.query.pagetitle){
            this.pagetitle = this.$route.query.pagetitle
        }
        this.search = this.$route.query || {};
        this.search.bid = this.$store.state.bid;
        this.loaded = false;
        let that = this;
        this.load().then(function(){
            that.loaded = true;
        })
    },
    methods:{
        to_project(id){
            this.$router.push('/product/project?id='+id+'&gid=0');
        },
        more(){
            if(this.page.page >= Math.ceil(parseInt(this.page.total) / parseInt(this.page.perpage))){
                this.finished = true;
                return;
            }
            this.page.page = parseInt(this.page.page) + 1;
            let that = this;
            this.request({
                url:this.url,
                data:{page:this.page,search:this.search}
            }).then(function(data){
                if(data.status == 200){
                    that.projects.push.apply(that.projects,data.data.projects)
                    that.loading = false;
                    if(that.page.page >= Math.ceil(parseInt(that.page.total) / parseInt(that.page.perpage))){
                        that.finished = true;
                        return;
                    }
                }
            })
        }
    }
}
</script>
<style scoped>

.flex{
    display: flex;
}
.flex-column{
    flex-direction: column;
}
.project-list{
    height:100%;
    overflow-y:auto;
}
.project-list-item{
    padding:10px 12px;
    background:#fff;
    margin-top:10px;
}
.list-content{
    margin-left:5px;
    display: flex;
    flex-direction:column;
    justify-content:space-between;
}
.project-list-item .img_wrap{
    width:130px;
    height:80px;
    flex-shrink:0;
}
.img_wrap .van-image{
    width:100%;
    height:100%;
    border-radius:3px;
    overflow:hidden;
}
.load-list{
    padding:0 12px;
}
</style>